import { render, staticRenderFns } from "./EcommerceCardTransaction.vue?vue&type=template&id=8f2be884&"
import script from "./EcommerceCardTransaction.vue?vue&type=script&lang=js&"
export * from "./EcommerceCardTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports